import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LiveStream } from 'types/stream';

import { streamSelectors } from '../../../../store/modules/stream';

const useLocalPending = (isPending?: boolean) => {
  const [isLocalPending, , removeLocalPending] = useSwitchState(true);

  useEffect(() => {
    isPending && removeLocalPending();
  }, [isPending]);

  return isLocalPending;
};

export const useStreamListResponseState = (list?: LiveStream[]) => {
  const isError = useSelector(streamSelectors.selectStreamsListIsError);
  const isPending = useSelector(streamSelectors.selectStreamsListIsPending);

  const isLocalPending = useLocalPending(isPending);
  const cahShowLoader = (isLocalPending || isPending) && !list?.[0];

  return [cahShowLoader, isError] as const;
};

export const useProjectStreams = () => {
  const projectStreamEntity = useSelector(streamSelectors.selectProjectStreamsEntity);

  const { isError, isPending, data } = projectStreamEntity;

  return [isError, isPending, data] as const;
};

export const usePastStreams = () => {
  const list = useSelector(streamSelectors.selectPastStreams);
  const [isPending, isError] = useStreamListResponseState(list);

  return [isPending, list, isError] as const;
};

export const useInProgressStreams = () => {
  const list = useSelector(streamSelectors.selectInProgressStreams);
  const [isPending, isError] = useStreamListResponseState(list);

  return [isPending, list, isError] as const;
};

export const useUpcomingStreams = () => {
  const list = useSelector(streamSelectors.selectUpcomingStreams);
  const [isPending, isError] = useStreamListResponseState(list);

  return [isPending, list, isError] as const;
};
